var Invocation = require('../api/Invocation');

var ClientServiceEmailActions = {
    changePassword: function (service, email, newPassword) {
        return Invocation.clientService.changeEmailPassword(service, email, newPassword);
    },

    createEmail: function (service, email, password) {
        return Invocation.clientService.createEmail(service, email, password);
    },

    deleteEmail: function (service, email) {
        return Invocation.clientService.deleteEmail(service, email);
    }
};
module.exports = ClientServiceEmailActions;



// WEBPACK FOOTER //
// ./app/actions/ClientServiceEmailActions.js